var map = {
	"./SPCAD_AUTOCAD.webp": 76331,
	"./SPCAD_BRICSCAD.webp": 49501,
	"./SPCAD_CADMATE.webp": 25679,
	"./SPCAD_GSTARCAD.webp": 73589,
	"./SPCAD_ZWCAD.webp": 71339,
	"./spcad+autocad.webp": 2383,
	"./spcad+bricscad.webp": 63585,
	"./spcad+cadmate.webp": 72019,
	"./spcad+gstarcad.webp": 36201,
	"./spcad+zwcad.webp": 35023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78614;